import { DataEntryDataType, type DataEntryColumnData } from '../../../../api/pages-client/pages-client.type';

type DataEntryWidgetForm = {
  id?: string;
  name: string;
  description: string;
  column_data: DataEntryColumnData[];
};

const DATA_ENTRY_DATA_TYPE_OPTIONS = [
  { value: DataEntryDataType.TEXT, label: 'Text' },
  { value: DataEntryDataType.FLOAT, label: 'Float' },
  { value: DataEntryDataType.INTEGER, label: 'Integer' },
  { value: DataEntryDataType.BOOLEAN, label: 'Boolean' },
  { value: DataEntryDataType.DATE, label: 'Date' },
  { value: DataEntryDataType.DATETIME, label: 'Datetime' },
];

export { DATA_ENTRY_DATA_TYPE_OPTIONS };
export type { DataEntryWidgetForm };
